<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Controle de Acesso" />

    <v-row v-if="filter.resource">
      <v-col cols="12" md="4" class="mb-4">
        <data-table-select-filter
          v-if="filter.type == 'select'"
          v-model="filter.model"
          :filter="filter"
          dense="compact"
        />
      </v-col>
    </v-row>

    <template v-if="data !== null">
      <access-control-summary-cards :sectors="data" />

      <access-control-table :sectors="data" @select-sector="onSelectSector" />
    </template>

    <sector-access-drawer
      v-if="selectedSector"
      :sector="selectedSector"
      @close="selectedSector = null"
    />
  </section>
</template>

<script lang="ts" setup>
import { ref, Ref, watch } from 'vue'
import TPageTitle from '@/components/TPageTitle.vue'
import DataTableSelectFilter from '@/components/datatable/DataTableSelectFilter.vue'
import EventService from '@/services/EventService'
import { useEventFilter } from '@/helpers/reports/eventFilter'
import { useProducerStore } from '@/stores/producer'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'
import type { AccessControlSector } from '@/types/AccessControl'
import AccessControlSummaryCards from './partials/access-control-summary-cards.vue'
import AccessControlTable from './partials/access-control-table.vue'
import SectorAccessDrawer from './partials/sector-access-drawer.vue'

const loader = useLoader()
const snackbar = useSnackBar()

const filter = ref(
  useEventFilter({
    producer: useProducerStore().producer!,
    label: 'Evento',
    field: 'event_id',
    type: 'select',
  }),
)

const data: Ref<AccessControlSector[] | null> = ref(null)
const selectedSector: Ref<AccessControlSector | null> = ref(null)

async function fetch() {
  try {
    loader.increment()

    await filter.value.ready

    const id = filter.value.value

    if (id === null) return

    const response = await new EventService().accessControl(id)

    data.value = response.data.data
    selectedSector.value = null
  } catch (error) {
    snackbar.show('Não foi possível buscar o controle de acesso', 'error')

    throw error
  } finally {
    loader.decrement()
  }
}

function onSelectSector(sectorId: string) {
  selectedSector.value = data.value?.find(sector => sector.sector_id === sectorId) ?? null
}

watch(() => filter.value.value, () => fetch())
</script>
